import React from 'react'
import './PropertyRentCompT1.scss'
import PropTypes from 'prop-types'
import {
  PropertyImage,
  UnitMix,
  PropertyInfo,
  AmenitiesT1,
  DonutChartT1,
  Notes
} from '@components/custom'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { RENT_COMPARABLES, RENT_COMPS_PAGE_TITLE } from '@engine/dependencies/constants'
export class PropertyRentCompT1 extends React.Component {

  editPropertyData = t => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, ...t })
  }

  editPropertyNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, isNotesModified: true, notes: n })
  }

  editPropertySourceNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, sourceNote: n })
  }

  render() {
    const {
      propertyType,
      templateDataLimits: { unitMixCount, amenitiesCount, notesCount, sourceNotesCount },
      toggleSettings,
      themeColors,
      donutChartThemeColors,
      templateName,
      propertyNameList
    } = this.props
    const {
      propertyData,
      comparableData,
      chartData,
      signedUrl,
      hideUnitMixTotal,
      unitMixDisclaimerData
    } = this.props.propertyInfoData
    const { hasBranding, hasAmenities, hasNotes, hasSourceNotes, hasPageTitle, hasDonut } = toggleSettings
    // const comparableDataT1 = [...comparableData]
    const AmenitiesT1Data = [...propertyData.amenities]
    const { showDisclaimer, disclaimerText } = propertyData

    // if (comparableDataT1.length > unitMixCount) {
    //   const comparableDataTotal = comparableDataT1.pop()
    //   comparableDataT1.splice(unitMixCount)
    //   comparableDataT1.push(comparableDataTotal)
    // }

    return (
      <div
        data-testid="property-rent-comps"
        className={(hasPageTitle || hasBranding) ? 'property-rent-comps-view-T1' : 'no-margin-property-rent-comps-view-T1'}
        id={`#property_${propertyType}`}
      >
        {(hasPageTitle || hasBranding) && (
          <>
            {propertyType.toString().includes('S') ? (
              <div>
                <div className="summary-header">
                  <span style={{ color: themeColors.globalColor }}>
                    {hasPageTitle && <>SUBJECT PROPERTY<p style={{ color: themeColors.globalSubColor }}>{` - ${RENT_COMPS_PAGE_TITLE}`}</p></>}
                  </span>
                  {hasBranding && (
                    <SummaryLogo data-testid="logo-long" className="summary_logo" />
                  )}
                </div>
                <div className="subject-property" />
              </div>
            ) : (
              <div className="property-rent-comps-heading summary-header">
                <span style={{ color: themeColors.globalSubColor }}>{hasPageTitle ? RENT_COMPS_PAGE_TITLE : ''}</span>
                {hasBranding && (
                  <SummaryLogo data-testid="logo-long" className="summary_logo" />
                )}
              </div>
            )}
          </>
        )}

        <div className="property-container">
          <div className="property-container-left">
            <PropertyImage
              propertyType={propertyType}
              imageUrl={signedUrl || ''}
              templateName={templateName}
            />
            <PropertyInfo
              propertyInfo={propertyData}
              propertyType={propertyType}
              templateName={templateName}
              propertyNameList={propertyNameList}
            />
            <div className="source_notes">
              {templateName.includes(RENT_COMPARABLES) && hasSourceNotes && (
                <Notes
                  notesContent={propertyData.sourceNote}
                  notesLimit={sourceNotesCount}
                  updateNotes={this.editPropertySourceNotes}
                  propertyLabel={'sourcenotes'}
                />
              )}
            </div>
            <div className="empty_notes">
              {templateName.includes(RENT_COMPARABLES) && hasNotes && (
                <Notes
                  notesContent={propertyData.notes}
                  notesLimit={notesCount}
                  updateNotes={this.editPropertyNotes}
                  propertyLabel={'notes'}
                  height={hasDonut ? '' : '345px'}
                />
              )}
            </div>
            {hasDonut && (
              <DonutChartT1
                chartData={chartData}
                donutChartThemeColors={donutChartThemeColors}
              />
            )}
          </div>
          <div className="property-container-right">
            <UnitMix comparableData={comparableData} hideUnitMixTotal={hideUnitMixTotal} unitMixCount={unitMixCount} propertyType={propertyType} unitMixDisclaimerData={unitMixDisclaimerData} />
            {hasAmenities && (
              <div className="amenities_t1">
                <AmenitiesT1
                  templateName={templateName}
                  amenities={AmenitiesT1Data}
                  amenitiesCount={amenitiesCount}
                  editPropertyData={this.editPropertyData}
                  propertyType={propertyType}
                  themeColors={themeColors}
                  disclaimerText={disclaimerText}
                  showDisclaimer={showDisclaimer}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

PropertyRentCompT1.propTypes = {
  donutChartThemeColors: PropTypes.object,
  amenitiesCount: PropTypes.number,
  editFeature: PropTypes.func,
  templateName: PropTypes.string,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasAmenities: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    hasDonut: PropTypes.bool
  }),
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  propertyInfoData: PropTypes.shape({
    propertyData: PropTypes.object,
    comparableData: PropTypes.arrayOf(
      PropTypes.object
    ),
    chartData: PropTypes.shape({
      '1 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 2 Bath': PropTypes.number,
      '3 Bedroom / 3 Bath': PropTypes.number
    }),
    signedUrl: PropTypes.string,
    hideUnitMixTotal: PropTypes.bool,
    unitMixDisclaimerData: PropTypes.object
  }),
  templateDataLimits: PropTypes.shape({
    unitMixCount: PropTypes.number,
    amenitiesCount: PropTypes.number,
    notesCount: PropTypes.number
  }),
  themeColors: PropTypes.object,
  propertyNameList: PropTypes.array
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  themeColors: Comps.selectors.comps.themeColors(state),
  templateName: Comps.selectors.comps.templateName(state)
})

export default connect(mapStateToProps)(PropertyRentCompT1)
